import { render, staticRenderFns } from "./studentR.vue?vue&type=template&id=c04df966&scoped=true&"
import script from "./studentR.vue?vue&type=script&lang=js&"
export * from "./studentR.vue?vue&type=script&lang=js&"
import style0 from "./studentR.vue?vue&type=style&index=0&id=c04df966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04df966",
  null
  
)

export default component.exports